import {FC} from "react";
import './styles.css';

interface HeaderProps {
}

const Header: FC<HeaderProps> = () => {  {
    return (
        <div className='App-header'>
            <div className='title'>Reinhardt van Wyk</div>
            <div className='header-links'>
                <a className='header-link' href='/'>Home</a>
                <a className='header-link' href='/aboutme'>About Me</a>
                <a className='header-link' href='/blog'>Blog</a>
            </div>
        </div>
    )
}}

export default Header;